import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import * as workerTimers from 'worker-timers';
import { get, set } from 'idb-keyval';

export default {
	start_time({commit, state}) {
		if (state.time_to !== null) return;
		// state.time_to = setInterval(function () { commit('increment_time') }, 1000 / state.speed)

		var start_time = new Date().getTime();
		var timer = 0;

		function instance(commit, state) {

			timer += 1000 / state.speed;
			commit('increment_time')

			var diff = (new Date().getTime()  - start_time) - timer;
			state.time_to = workerTimers.setTimeout(function() { instance(commit, state) }, (1000 / state.speed) - diff);
		}

		state.time_to = workerTimers.setTimeout(function() { instance(commit, state) }, 1000 / state.speed);
		state.paused = false;

	},
	end_time({state}) {
		if (state.time_to !== null) workerTimers.clearTimeout(state.time_to);
		state.time_to = null;
		state.paused = true;
	},
	save(context, data) {

		let save_options = ['map', 'location', 'floor_level', 'speed', 'time', 'clock', 'day', 'watcher', 'log', 'alert', 'muster', 'bottom_menu_collapsed', 'workers', 'havoc', 'base_layer', 'start_date', 'move_watcher', 'worker_status', 'vehicles', 'position', 'proximity'];

		this.state.map.center = this.state.map.map.getView().getCenter();
		this.state.map.zoom = this.state.map.map.getView().getZoom();
		this.state.map.rotation = this.state.map.map.getView().getRotation();

		let save = {};
		for (let i in save_options) {
			let field = save_options[i]

			if (typeof this.state[field] === 'object') save[field] = $.extend(true, {}, this.state[field]);
			else save[field] = this.state[field]

			if (field == 'map') {
				for (let j in save.map) {
					if (Vue.prototype.$finder.isCyclic(save[field][j])) save[field][j] = null;
				}
			}
			else if (field == 'workers' || field == 'vehicles') {
				for (let j in save[field]) {
					for (let k in save[field][j])
						if (Vue.prototype.$finder.isCyclic(save[field][j][k])) save[field][j][k] = null;
				}
			}

		}

		set('save-' + data.save_name, save)
			.then()
			.catch(err => this.state.error = 'Data saving error.');

	},
	async load(context, payload) {

		let data;
		if (payload.storage_item == 'sample') data = sample_scenario;
		else {
			data = await get(payload.storage_item)
		}

		context.dispatch('end_time');

		for (let i in data) {
			if (i == 'map' || i == 'workers' || i == 'vehicles') continue;
			this.state[i] = data[i];
		}
		this.state.load = payload.storage_item;
		this.state.save_file = payload.storage_item.replace('save-', '');

	},
	filterWorkers({ commit }, value) {
		commit('set_filteredWorkers', value)
	}
}
